export enum FormatType {
  SOCKET = 'socket',
  CABLE = 'cable',
}
